export default function EmptyWrapper({ children }) {
  return children;
}
